
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_7o1el_17",
  "arrow": "awsui_arrow_18eso_7o1el_17",
  "in-filtering-token-root": "awsui_in-filtering-token-root_18eso_7o1el_77",
  "in-filtering-token-nested": "awsui_in-filtering-token-nested_18eso_7o1el_77",
  "has-caret": "awsui_has-caret_18eso_7o1el_113",
  "placeholder": "awsui_placeholder_18eso_7o1el_116",
  "pressed": "awsui_pressed_18eso_7o1el_132",
  "disabled": "awsui_disabled_18eso_7o1el_138",
  "in-filtering-token": "awsui_in-filtering-token_18eso_7o1el_77",
  "readonly": "awsui_readonly_18eso_7o1el_159",
  "compact": "awsui_compact_18eso_7o1el_171",
  "grouped": "awsui_grouped_18eso_7o1el_171",
  "with-error": "awsui_with-error_18eso_7o1el_171",
  "with-warning": "awsui_with-warning_18eso_7o1el_171",
  "invalid": "awsui_invalid_18eso_7o1el_180",
  "warning": "awsui_warning_18eso_7o1el_189",
  "custom-option": "awsui_custom-option_18eso_7o1el_204",
  "inline-tokens": "awsui_inline-tokens_18eso_7o1el_209",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_18eso_7o1el_261",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_18eso_7o1el_265",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_18eso_7o1el_271",
  "grouped-vertical-first": "awsui_grouped-vertical-first_18eso_7o1el_275",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_18eso_7o1el_279",
  "grouped-vertical-last": "awsui_grouped-vertical-last_18eso_7o1el_285",
  "grouped-with-action": "awsui_grouped-with-action_18eso_7o1el_289",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_18eso_7o1el_321",
  "grouped-vertical-only": "awsui_grouped-vertical-only_18eso_7o1el_321",
  "grouped-validation-first": "awsui_grouped-validation-first_18eso_7o1el_369"
};
  